import { EVENTS } from "./constants";
import { http } from "./httpServices";

export function uploadAmdImage(data: any) {
  const formData = new FormData();
  formData.append("file", data);
  return http.post(`${EVENTS}/uploadFiles`, formData);
}

export function getExpiryList(searchText: string) {
  return http.get(`/membership/expiryList`, {
    params: {
      searchText: searchText,
    },
  });
}

export function membershipRegister(data: any) {
  return http.post('/membership/register', data);
}